import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { drawerWidth } from "../constants";
import { Button, Grid } from "@mui/material";

const Header = ({ mainTitle, bgColor, buttonText, handleSubmit }) => {
  return (
    <AppBar
      position="fixed"
      sx={{
        width: `calc(100% - ${drawerWidth}px)`,
        ml: `${drawerWidth}px`,
        background: bgColor ? bgColor : "#F5F5F5",
        boxShadow: "none",
      }}
    >
      <Toolbar>
        <Grid container alignItems={"center"}>
          <Grid item xs container alignItems={"center"}>
            <Typography style={mainTitleStyles}>
              {mainTitle && mainTitle}
            </Typography>
          </Grid>
          <Grid item xs container>
            {buttonText && (
              <Button
                variant="contained"
                style={buttonStyles}
                onClick={() => handleSubmit()}
              >
                {buttonText}
              </Button>
            )}
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default Header;

const mainTitleStyles = {
  color: "#020303",
  fontSize: 24,
  fontWeight: 700,
  fontFamily: 'Avenir Book, sans-serif',
  // paddingLeft: 20,
};

const buttonStyles = {
  marginLeft: "auto",
  marginRight: 30,
  textTransform: "none",
  background: "#00A7CD",
  fontSize: 15,
  fontWeight: 500,
  cursor: "pointer",
  fontFamily: 'Avenir Book, sans-serif',
};
